import {
  AGGIUNGI,
  SALVA,
  SCARICA,
  SEGUI,
  VALUTA,
  api,
  downloadables,
  getTipoStrumento,
  hasPerm,
  isFlipchart,
  mappingCta,
  mappingValuta,
  isSme,
  CAS_DOMAIN,
} from '../../utils'
import { ELEMENTIRACCOLTA, ELEMENTOSALVATO, ELEMENTOSEGUITO, RACCOLTE } from 'utils/endpoint'
import { useEffect, useMemo, useState } from 'react'

import Icon from './Icon'
import Limit from './Limit'
import Link from 'next/link'
import Trans from './Trans'
import { connect } from 'react-redux'
import dynamic from 'next/dynamic'
import { sendGTMData } from '../../utils/gtm'
import { useRouter } from 'next/router'

const Dropdown = dynamic(() => import('./Dropdown'))
const EmbeddedVimeo = dynamic(() => import('./EmbeddedVimeo'))
const ShareButtons = dynamic(() => import('./ShareButtons'))
const FormRaccolta = dynamic(() => import('../area_personale/FormRaccolta'))
const Login = dynamic(() => import('./Login'))
const Modal = dynamic(() => import('./Modal'))

api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

const getLabel = (item) => mappingValuta[item.model_class]

const initialComunicazione = {
  stato: false,
  type: '',
}

const Actionbar = (props) => {
  const {
    item,
    utente,
    paginaCorrente,
    customCta = null,
    reviewsToggle = null,
    commenti = null,
    follow = false,
    save = false,
    download = false,
    addTo = false,
    sfoglia = false,
    faq = false,
    progetti = false,
    censura = false,
  } = props

  const router = useRouter()

  // STATE
  const [fixed, setFixed] = useState(false)
  const [followed, setFollowed] = useState(false)
  const [saved, setSaved] = useState(false)

  const [raccolte, setRaccolte] = useState([])
  const [raccolta, setRaccolta] = useState(null)

  // MODAL
  const [saveModal, setSaveModal] = useState(false)
  const [addToModal, setAddToModal] = useState(false)
  const [shareModal, setShareModal] = useState(false)
  const [downloadModal, setDownloadModal] = useState(false)
  const [copiedToClipboard, setCopiedToClipboard] = useState(false)
  const [vimeoModal, setVimeoModal] = useState(false)
  const [login, setLogin] = useState(false)
  const [next, setNext] = useState('')
  const [comunicazione, setComunicazione] = useState(initialComunicazione)

  const handleLogin = (login, nextPage = '') => {
    if (nextPage) setNext(nextPage)
    setComunicazione(initialComunicazione)
    setLogin(login)
  }

  const params = { content_type_id: item.model, object_id: item.id }

  const getLabelGTM = () => {
    let eventLabel = ''
    if (paginaCorrente?.item?.model_class === 'strumento') {
      eventLabel = getTipoStrumento(paginaCorrente.item).split(' ')[0]
      if (eventLabel == 'scheda') {
        eventLabel = 'scheda_didattica'
      }
    } else {
      if (paginaCorrente?.item?.tipologia) {
        eventLabel = paginaCorrente?.item?.tipologia
      } else {
        eventLabel = paginaCorrente?.item?.model_class || ''
      }

      if (paginaCorrente?.autore) {
        eventLabel = 'autori'
      }
    }
    return eventLabel
  }

  const handleFixed = (response) => {
    setFixed(response)
  }

  useEffect(() => {
    if (hasPerm(utente, SEGUI)) checkFollowed()
    if (hasPerm(utente, SALVA)) checkSaved()
  }, [])

  const checkFollowed = async () => {
    api.get(ELEMENTOSEGUITO, { params }).then((response) => {
      const followed = response.data['seguito']
      setFollowed(followed)
    })
  }

  const handleFollow = async () => {
    api.post(ELEMENTOSEGUITO, { params }).then((response) => {
      setFollowed(response.data['created'])

      sendGTMData({
        event: 'GAevent',
        eventID: '16',
        eventCategory: 'cta_banner',
        eventAction: 'segui',
        eventLabel: getLabelGTM(),
        moreInfo: paginaCorrente?.item?.titolo.toGTMFormat() || '',
      })
    })
  }

  const handleUnFollow = async () => {
    api.delete(ELEMENTOSEGUITO, { data: params }).then((response) => {
      setFollowed(!response.data.success)
    })
  }

  const checkSaved = async () => {
    api.get(ELEMENTOSALVATO, { params }).then((response) => {
      setSaved(response.data['salvato'])
    })
  }

  const handleSave = async () => {
    if (hasPerm(utente, SALVA)) {
      api.post(ELEMENTOSALVATO, { params }).then((response) => {
        const saved = response.data['created']
        sendGTMData({
          event: 'GAevent',
          eventID: '16',
          eventCategory: 'bookmark',
          eventAction: 'salva',
          eventLabel: getLabelGTM(),
          moreInfo: paginaCorrente?.item?.titolo.toGTMFormat() || '',
        })
        setSaved(saved)
        setSaveModal(saved)
      })
    } else {
      setComunicazione({ stato: true, type: SALVA })
    }
  }

  const handleUnsave = async () => {
    api.delete(ELEMENTOSALVATO, { data: params }).then((response) => {
      setSaved(!response.data.success)
    })
  }

  const handleAddToModal = () => {
    if (hasPerm(utente, AGGIUNGI)) {
      sendGTMData({
        event: 'GAevent',
        eventID: '16',
        eventCategory: 'cta_banner',
        eventAction: 'aggiungi_alla_raccolta',
        eventLabel: getLabelGTM(),
        moreInfo: paginaCorrente?.item?.titolo.toGTMFormat() || '',
      })
      setAddToModal(true)
      fetchRaccolte()
    } else {
      setComunicazione({ stato: true, type: AGGIUNGI })
    }
  }

  const handleCreaRaccolta = (response) => {
    handleAddTo(null, response.data.raccolta, true)
  }

  const handleAddTo = (e, id = null, created) => {
    if (e) {
      let r = raccolta ? raccolte.filter((el) => el.value === raccolta) : null
      if (r && r.length > 0) r = r[0]

      sendGTMData({
        event: 'GAevent',
        eventID: '17',
        eventCategory: 'raccolta',
        eventAction: 'aggiungi_contenuto',
        eventLabel: r?.pubblica ? 'pubblica' : 'privata',
      })
      if (created) {
        sendGTMData({
          event: 'GAevent',
          eventID: '17',
          eventCategory: 'raccolta',
          eventAction: 'crea_nuova_raccolta',
          eventLabel: 'privata',
        })
      }
    }
    api
      .post(ELEMENTIRACCOLTA, {
        raccolta_id: id || raccolta,
        object_id: item.id,
        content_type_id: item.model,
      })
      .then(() => setAddToModal(false))
  }

  const handleOnChange = ({ value, label }) => {
    setRaccolta(value)
  }

  const handleGTMCta = (ctaAction) => {
    sendGTMData({
      event: 'GAevent',
      eventID: '16',
      eventCategory: 'cta_banner',
      eventAction: ctaAction,
      eventLabel: getLabelGTM(),
      moreInfo: paginaCorrente?.item?.titolo.toGTMFormat() || '',
    })
  }

  const fetchRaccolte = async () => {
    api.get(RACCOLTE, { params: { utenti__id: utente.id, all: true } }).then((response) => {
      const raccolte = response.data.results
      setRaccolte(
        raccolte.map(({ id, titolo, pubblica }) => ({ value: id, label: titolo, pubblica }))
      )
    })
  }

  const reviewsCta = () => {
    if (hasPerm(utente, VALUTA)) {
      sendGTMData({
        event: 'GAevent',
        eventID: '16',
        eventCategory: 'cta_banner',
        eventAction:
          paginaCorrente?.item?.model_class == 'raccolta'
            ? 'valuta_la_raccolta'
            : 'valuta_lo_strumento',
        eventLabel: getLabelGTM(),
        moreInfo: paginaCorrente?.item?.titolo.toGTMFormat() || '',
      })
      reviewsToggle()
    } else {
      setComunicazione({ stato: true, type: VALUTA })
    }
  }

  let cta = null
  let tipoStrumento = null

  if (item.model_class === 'strumento') {
    tipoStrumento = useMemo(() => getTipoStrumento(item), [item])

    const ctaLabel = item.cta ? item.cta : mappingCta[tipoStrumento.split(' ')[0]]

    const isDownloadable = downloadables.includes(tipoStrumento.split(' ')[0])

    if (item.extra?.id_vimeo) {
      cta = (
        <button
          className="button button--primary button--inverted"
          onClick={() => setVimeoModal(true)}
        >
          {ctaLabel}
        </button>
      )
    } else if (item.link_esterno || item.extra.file_url) {
      cta = (
        <a
          className="button button--primary button--inverted"
          download={
            isDownloadable
              ? isFlipchart(item)
                ? item.titolo + '.flipchart'
                : isSme(item)
                ? item.titolo + '.sme'
                : true
              : false
          }
          target="_blank"
          href={item.link_esterno || item.extra.file_url}
          onClick={() => handleGTMCta(ctaLabel == 'ISCRIVITI' ? 'iscriviti' : 'download')}
        >
          {ctaLabel}
        </a>
      )
    } else {
      cta = (
        <button
          className="button button--primary button--inverted disabled"
          onClick={() => handleDownload(true)}
        >
          {ctaLabel}
        </button>
      )
    }
  } else if (item.model_class === 'parascolastico' && item.cta) {
    const ctaLabel = item.cta ? item.cta : <Trans chiave="Sfoglia" />

    cta = (
      <a
        className="button button--primary button--inverted"
        target="_blank"
        href={item.link_esterno || '#'}
        onClick={() => handleGTMCta(item.cta ? item.cta : 'sfoglia')}
      >
        {ctaLabel}
      </a>
    )
  } else if (item.model_class === 'corsoadozionale') {
    const ctaLabel = item.link_dbook_easy ? (
      <Trans chiave="Vai su Dbookeasy" />
    ) : (
      <Trans chiave="Richiedi saggio digitale" />
    )

    const href = item.link_dbook_easy
      ? item.link_dbook_easy
      : 'mailto:giuntiscuoladigitale@giunti.it'

    const gtmCta = item.link_dbook_easy ? 'dbookeasy' : 'email'

    cta = (
      <a
        className="button button--primary button--inverted"
        href={href}
        onClick={() => handleGTMCta(gtmCta)}
        target={item.link_dbook_easy ? '_blank' : null}
      >
        {ctaLabel}
      </a>
    )
  }

  const handlePrint = () => {
    sendGTMData({
      event: 'GAevent',
      eventID: '16',
      eventCategory: 'cta_banner',
      eventAction: 'stampa',
      eventLabel: getLabelGTM(),
      moreInfo: paginaCorrente?.item?.titolo.toGTMFormat() || '',
    })
    window.print()
  }

  const handleShare = () => {
    sendGTMData({
      event: 'GAevent',
      eventID: '16',
      eventCategory: 'cta_banner',
      eventAction: 'condividi',
      eventLabel: getLabelGTM(),
      moreInfo: paginaCorrente?.item?.titolo.toGTMFormat() || '',
    })
    setShareModal(true)
  }

  const handleCopyToClipboard = () => {
    const ua = window.navigator.userAgent
    const isIE = /MSIE|Trident/.test(ua)

    if (!isIE) {
      window.navigator.clipboard.writeText(window.location.href).then(
        () => {
          sendGTMData({
            event: 'GAevent',
            eventID: '16',
            eventCategory: 'cta_banner',
            eventAction: 'copia_link',
            eventLabel: getLabelGTM(),
            moreInfo: paginaCorrente?.item?.titolo.toGTMFormat() || '',
          })
          setCopiedToClipboard(true)
          setTimeout(() => setCopiedToClipboard(false), 2000)
        },
        (err) => alert('Could not copy text: ', err)
      )
    } else {
      // TODO: gestione IE
    }
  }

  const handleDownload = (force = false) => {
    if (hasPerm(utente, SCARICA, item) && !force) {
      sendGTMData({
        event: 'GAevent',
        eventID: '16',
        eventCategory: 'cta_banner',
        eventAction: 'download',
        eventLabel: getLabelGTM(),
        moreInfo: paginaCorrente?.item?.titolo.toGTMFormat() || '',
      })
      setDownloadModal(true)
    } else {
      setComunicazione({ stato: true, type: SCARICA })
    }
  }

  const renderIscrivitiCtaMobile = () =>
    progetti &&
    item.link_esterno && (
      <a
        href={item.link_esterno}
        className="button button--primary button--inverted"
        target="_blank"
      >
        <p style={{ textAlign: 'center' }}>{item.cta || 'Iscriviti'}</p>
      </a>
    )

  const renderComunicazione = (utente, item) => {
    if (item.con_codice) {
      return (
        <>
          <h3 className="title">Inserisci il codice ISBN e sblocca questo contenuto!</h3>
          <p className="disclaimer">
            Sotto il codice a barre del libro trovi il codice ISBN, inseriscilo per accedere subito
            a tutti i contenuti del libro.
          </p>
          {utente ? (
            <Link legacyBehavior href="/area-personale/libreria">
              <a className="button button--primary cta" type="button">
                Inserisci il codice
              </a>
            </Link>
          ) : (
            <button
              className="button button--primary cta"
              type="button"
              onClick={() => handleLogin(true, 'area-personale-libreria')}
            >
              Inserisci il codice
            </button>
          )}
        </>
      )
    } else if (!utente) {
      return (
        <>
          <h3 className="title">Questo contenuto è riservato agli utenti registrati.</h3>
          <p className="disclaimer">
            Registrati gratuitamente e scopri tutti i vantaggi. In regalo per te 30 giorni di prova
            a IO+, con tanti contenuti in esclusiva e l'accesso alla community dei docenti Giunti
            Scuola.
          </p>
          <Link legacyBehavior href="/registrazione">
            <a
              className="button button--primary cta"
              type="button"
              onClick={() => setComunicazione(initialComunicazione)}
            >
              Registrati ora
            </a>
          </Link>
          <p className="disclaimer">
            Registrati ora e accedi a tanti contenuti, <b>sempre aggiornati</b>
          </p>
          <p>
            Sei già registrato?{' '}
            <a className="login" onClick={() => handleLogin(true)}>
              Accedi
            </a>
          </p>
        </>
      )
    } else if (!utente.is_member) {
      return (
        <>
          <h3 className="title">
            Questo contenuto è riservato agli abbonati IO+, la community dei docenti Giunti Scuola.
          </h3>
          <p className="disclaimer">
            Provalo gratuitamente per 30 giorni, e scopri tutti i materiali a disposizione per te:
            percorsi didattici, materiali per le lezioni e molto altro.
          </p>
          <a className="button button--primary cta" type="button" href="/io-piu">
            Abbonati a io+
          </a>
          {/* <p className="disclaimer">
            per te, <b>30 giorni di prova gratuita</b>
          </p> */}
          <p>
            Sei già abbonato?{' '}
            <a className="login" onClick={() => handleLogin(true)}>
              Accedi
            </a>
          </p>
        </>
      )
    }

    return null
  }

  return (
    <>
      <Limit handleFixed={handleFixed} />
      <div className={`actionbar ${fixed ? 'actionbar--fixed' : ''}`}>
        <div className="actionbar__buttons">
          {cta}
          {customCta}
          {download && (
            <button
              className={`button button--primary button--inverted ${
                !hasPerm(utente, SCARICA, item) ? 'disabled' : ''
              }`}
              onClick={() => handleDownload(false)}
            >
              <Trans chiave="Scarica" />
            </button>
          )}
          {item.extra?.zip_elementi ? (
            <a
              className="button button--primary button--inverted"
              href={item.extra.zip_elementi}
              download
            >
              <Trans chiave="Scarica" />
            </a>
          ) : null}
          {sfoglia && item.link_esterno && (
            <a
              className="button button--primary button--inverted"
              target="_blank"
              href={item.link_esterno}
              onClick={() => handleGTMCta('sfoglia')}
            >
              <Trans chiave="Sfoglia" />
            </a>
          )}
          {follow ? (
            followed ? (
              <button
                onClick={handleUnFollow}
                className="button button--primary button--inverted"
                disabled={!hasPerm(utente, SEGUI)}
              >
                <Trans chiave="Smetti di seguire" key={followed} />
              </button>
            ) : (
              <button
                onClick={handleFollow}
                className="button button--primary button--inverted"
                disabled={!hasPerm(utente, SEGUI)}
              >
                <Trans chiave="Segui" key={followed} />
              </button>
            )
          ) : null}
          {addTo && (
            <button
              className={`button button--secondary button--inverted ${
                !hasPerm(utente, AGGIUNGI) ? 'disabled' : ''
              }`}
              onClick={handleAddToModal}
            >
              <Trans chiave="Aggiungi alla raccolta" />
            </button>
          )}
          {!censura && reviewsToggle && (
            <button
              className={`button button--tertiary button--inverted ${
                !hasPerm(utente, VALUTA) ? 'disabled' : ''
              }`}
              onClick={reviewsCta}
            >
              {commenti ? (
                <span className="actionbar__comments">
                  {item.num_commenti} <Icon id="comment" />
                </span>
              ) : null}
              {getLabel(item) ? (
                <>
                  {getLabel(item)} <Icon id="arrow-right" classes="button__arrow" />
                </>
              ) : null}
            </button>
          )}
          {faq && (
            <Link legacyBehavior href={`${item.url}faq`}>
              <a className="button button--tertiary button--inverted">
                <Trans chiave="Vai alle FAQ" /> <Icon id="arrow-right" classes="button__arrow" />
              </a>
            </Link>
          )}
        </div>
        {!utente ? (
          <div className="actionbar__description">
            <Trans chiave="Accedi a materiali in esclusiva, " />
            <a onClick={() => handleLogin(true)}>
              registrati <span>o</span> accedi!
            </a>
          </div>
        ) : utente && !utente.is_member ? (
          <div className="actionbar__description">
            <Trans chiave="Accedi a materiali in esclusiva, " />
            <a href="/io-piu">abbonati</a>
          </div>
        ) : null}
        <div className="actionbar__icons">
          {save ? (
            saved ? (
              <button
                className="button button--tertiary button--inverted button--icon"
                onClick={handleUnsave}
                disabled={!hasPerm(utente, SALVA)}
              >
                <Icon id="bookmark" classes="actionbar__icons__save" key={saved} />
              </button>
            ) : (
              <button
                className={`button button--tertiary button--inverted button--icon ${
                  !hasPerm(utente, SALVA) ? 'disabled' : ''
                }`}
                onClick={handleSave}
              >
                <Icon id="bookmark-empty" classes="actionbar__icons__save" key={saved} />
              </button>
            )
          ) : null}
          <button
            className="button button--primary button--inverted button--icon"
            onClick={handleShare}
          >
            <Icon id="share" />
          </button>
          <a
            className="button button--primary button--inverted button--icon"
            href={`mailto:?subject=GIUNTI Scuola | ${item.titolo}&body=${CAS_DOMAIN}${router.asPath}`}
            onClick={() => handleGTMCta('email')}
          >
            <Icon id="email" />
          </a>
          <button
            className="button button--primary button--inverted button--icon"
            onClick={handlePrint}
          >
            <Icon id="print" />
          </button>
          <button
            className="button button--primary button--inverted button--icon"
            onClick={handleCopyToClipboard}
          >
            <Icon id="link" />
          </button>
        </div>

        <div className="actionbar__mobile">
          {cta}
          {follow ? (
            followed ? (
              <button
                onClick={handleUnFollow}
                className="button button--primary button--inverted"
                disabled={!hasPerm(utente, SEGUI)}
              >
                <Trans chiave="Smetti di seguire" key={followed} />
              </button>
            ) : (
              <button
                onClick={handleFollow}
                className="button button--primary button--inverted"
                disabled={!hasPerm(utente, SEGUI)}
              >
                <Trans chiave="Segui" key={followed} />
              </button>
            )
          ) : null}
          {renderIscrivitiCtaMobile()}
          {faq && (
            <button className="button button--tertiary button--icon-text button--inverted">
              <Link legacyBehavior href={`${item.url}faq`}>
                <div>
                  <span>
                    <Icon id="faq--colored" />
                    <Trans chiave="Vai alle FAQ" />
                  </span>
                </div>
              </Link>
            </button>
          )}
          {download && (
            <button
              className={`button button--tertiary button--icon-text button--inverted ${
                !hasPerm(utente, SCARICA, item) ? 'disabled' : ''
              }`}
              onClick={() => handleDownload(false)}
            >
              <Icon id="download2" />
              <span>
                <Trans chiave="Scarica" />
              </span>
            </button>
          )}
          {addTo && (
            <button
              className={`button button--tertiary button--icon-text button--inverted ${
                !hasPerm(utente, AGGIUNGI) ? 'disabled' : ''
              }`}
              onClick={handleAddToModal}
            >
              <Icon id="add" />
              <span>
                <Trans chiave="Aggiungi" />
              </span>
            </button>
          )}
          {!censura && reviewsToggle && (
            <button
              className={`button button--tertiary button--icon-text button--inverted ${
                !hasPerm(utente, VALUTA) ? 'disabled' : ''
              }`}
              onClick={reviewsCta}
            >
              <Icon id="comment-plus" />
              <span>
                <Trans chiave="Commenta" />
              </span>
            </button>
          )}

          {save ? (
            saved ? (
              <button
                className="button button--tertiary button--icon-text button--inverted"
                onClick={handleUnsave}
                disabled={!hasPerm(utente, SALVA)}
              >
                <Icon id="bookmark" key={saved} />
                <span>
                  <Trans chiave="Rimuovi" key={saved} />
                </span>
              </button>
            ) : (
              <button
                className={`button button--tertiary button--icon-text button--inverted ${
                  !hasPerm(utente, SALVA) ? 'disabled' : ''
                }`}
                onClick={handleSave}
              >
                <Icon id="bookmark-empty" key={saved} />
                <span>
                  <Trans chiave="Salva" key={saved} />
                </span>
              </button>
            )
          ) : null}

          {sfoglia && item.link_esterno && (
            <a
              className="button button--tertiary button--icon-text button--inverted"
              target="_blank"
              href={item.link_esterno}
              onClick={() => handleGTMCta('sfoglia')}
            >
              <Icon id="cat-libro" />
              <span>
                <Trans chiave="Sfoglia" />
              </span>
            </a>
          )}

          <button
            className="button button--tertiary button--icon-text button--inverted"
            onClick={handleShare}
          >
            <Icon id="share" />
            <span>
              <Trans chiave="Condividi" />
            </span>
          </button>
        </div>
      </div>
      {saveModal && (
        <Modal isOpen={saveModal} alert={false} close={() => setSaveModal(false)}>
          <div className="modal__content__saved">
            <Icon id="check3" classes="icon--check" />
            <p className="title">
              <Trans chiave="L’elemento è stato salvato!" />
            </p>
            <p className="disclaimer">
              <Trans chiave="Troverai l’elemento salvato all'interno della sezione dedicata nel tuo profilo personale" />
            </p>
          </div>
        </Modal>
      )}
      {shareModal && (
        <Modal isOpen={shareModal} alert={false} close={() => setShareModal(false)}>
          <div className="modal__content__share">
            <p className="title">
              <Trans chiave="Condividi sui social" />
            </p>
            <ShareButtons />
          </div>
        </Modal>
      )}
      {downloadModal && (
        <Modal isOpen={downloadModal} alert={false} close={() => setDownloadModal(false)}>
          <div className="modal__content__download">
            <p className="title">
              <Trans chiave="Scarica" />
            </p>
            <p className="disclaimer">
              <Trans chiave="Lorem ipsum scarica articolo" />
            </p>
            <div className="w-container content">
              <div className="row">
                {item.zip_file && (
                  <div className="col col-md-6 content__item">
                    <p>
                      <Trans chiave="Ottieni lo zip completo dei materiali" />
                    </p>
                    <a className="button button--primary" href={item.zip_file} download>
                      <Trans chiave="Scarica .zip" />
                    </a>
                  </div>
                )}
                <div className="col col-md-6 content__item">
                  {item.pdf_file && (
                    <>
                      <p>
                        <Trans chiave="Scarica il PDF" />
                      </p>
                      <a className="button button--primary" href={item.pdf_file} download>
                        <Trans chiave="Scarica .pdf" />
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {addToModal && (
        <Modal isOpen={addToModal} alert={false} close={() => setAddToModal(false)}>
          <div className="modal__content__add">
            <p className="title">
              <Trans chiave="Aggiungi alla raccolta" />
            </p>
            <Dropdown
              instanceId={'raccolte'}
              placeholder={'Le tue raccolte'}
              options={raccolte}
              onChange={handleOnChange}
              isDisabled={!raccolte.length}
            />
            <button
              className="button button--primary cta"
              type="button"
              disabled={!raccolte.length || !raccolta}
              onClick={handleAddTo}
            >
              <Trans chiave="Aggiungi" />
            </button>
            <p className="disclaimer">
              <Trans chiave="Oppure crea una nuova raccolta" />
            </p>
            <FormRaccolta modal onSubmit={handleCreaRaccolta} />
          </div>
        </Modal>
      )}
      {vimeoModal && (
        <Modal
          isOpen={vimeoModal}
          alert={false}
          close={() => setVimeoModal(false)}
          classes="modal__content--wide"
        >
          <div className="modal__content__vimeo">
            <EmbeddedVimeo id={item.extra?.id_vimeo} />
          </div>
        </Modal>
      )}
      {comunicazione.stato && (
        <Modal
          isOpen={comunicazione.stato}
          alert={false}
          close={() => setComunicazione(initialComunicazione)}
          classes="modal__content--wide"
        >
          <div className="modal__content__comunicazione">{renderComunicazione(utente, item)}</div>
        </Modal>
      )}
      {copiedToClipboard && (
        <div className="copied-to-clipboard">
          <Trans chiave="Il link è stato copiato nei tuoi appunti!" />
        </div>
      )}
      {login && <Login isOpen={login} next={next} setLogin={handleLogin} />}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    utente: state.utente.utente,
    paginaCorrente: state.paginaCorrente.paginaCorrente,
  }
}

export default connect(mapStateToProps, null)(Actionbar)
